import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import {
    getFunctionalLocationInfoRequest,
    getFunctionalLocationInfoSuccess,
    resetSaveSuccess,
    saveFunctionalLocationInfoRequest,
} from './info-actions';
import { blockNavigation } from '../../../common/navigation/containers/navigation-actions';
import Info from '../components/info';

const mapStateToProps = (state) => {
    const activeServiceCenter = state.navigation.navigationSelf.serviceCenterId;
    return {
        data: state.functionalLocations.info.data,
        isLoading: state.functionalLocations.info.isLoading,
        error: state.functionalLocations.info.error,
        isSaving: state.functionalLocations.info.isSaving,
        saveSuccess: state.functionalLocations.info.saveSuccess,
        lock: state.functionalLocations.info.lock,
        lockingErrorType: state.functionalLocations.info.lockingErrorType,
        partners: state.functionalLocations.info.partners,
        userStatuses: state.functionalLocations.info.userStatuses,
        // eslint-disable-next-line max-len
        partnerTypes: state.referenceData.data[`${activeServiceCenter}_functionallocation_partnerTypes`],
        taskLists: state.functionalLocations.info.taskLists,
        visitTypes: state.functionalLocations.info.visitTypes,
        lockingErrors: state.functionalLocations.info.lockingErrors,
    };
};

const mapDispatchToProps = {
    getFunctionalLocationInfoRequest,
    saveFunctionalLocationInfoRequest,
    resetSaveSuccess,
    getFunctionalLocationInfoSuccess,
    blockNavigation,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Info));
